/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CapHpiDvlaDTO } from '../models/CapHpiDvlaDTO';
import type { NewQuotaInput } from '../models/NewQuotaInput';
import type { ServiceListDto } from '../models/ServiceListDto';
import type { ServiceListItemDto } from '../models/ServiceListItemDto';
import type { ServicePlanDetailDto } from '../models/ServicePlanDetailDto';
import type { ServicePlanDetailsStatus } from '../models/ServicePlanDetailsStatus';
import type { ServicePlanInputPdf } from '../models/ServicePlanInputPdf';
import type { ServicePlanStatus } from '../models/ServicePlanStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ServicePlanService {

  /**
   * @param page 
   * @param pageSize 
   * @param from 
   * @param to 
   * @param status
 *
 * 1 = SignedNotCompleted
 *
 * 2 = Subscribed
 *
 * 3 = RequestCancellation
 *
 * 4 = Cancelled
 *
 * 10 = Undefined1
 *
 * 20 = Undefined2
 *
 * 40 = Scheduled
 *
 * 60 = Undefined3
 *
 * 80 = Other
 *
 * 90 = Completed
   * @returns any Success
   * @throws ApiError
   */
  public static getServicePlanGetFilteredServicePlan(
page?: number,
pageSize?: number,
from?: string,
to?: string,
status?: ServicePlanStatus,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ServicePlan/GetFilteredServicePlan',
      query: {
        'Page': page,
        'PageSize': pageSize,
        'from': from,
        'to': to,
        'status': status,
      },
    });
  }

  /**
   * @param branchId 
   * @param modelName 
   * @param manufName 
   * @param fuelTypeName 
   * @param fuelTypeId 
   * @param regDate 
   * @param nextServiceDate 
   * @param varclass 
   * @returns ServiceListDto Success
   * @throws ApiError
   */
  public static getServicePlanGetServices(
branchId?: number,
modelName?: string,
manufName?: string,
fuelTypeName?: string,
fuelTypeId?: number,
regDate?: string,
nextServiceDate?: string,
varclass?: string,
): CancelablePromise<ServiceListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ServicePlan/GetServices',
      query: {
        'BranchId': branchId,
        'ModelName': modelName,
        'ManufName': manufName,
        'FuelTypeName': fuelTypeName,
        'FuelTypeId': fuelTypeId,
        'RegDate': regDate,
        'NextServiceDate': nextServiceDate,
        'Varclass': varclass,
      },
    });
  }

  /**
   * @param branchId 
   * @returns ServiceListItemDto Success
   * @throws ApiError
   */
  public static getServicePlanGetServicesAddons(
branchId?: number,
): CancelablePromise<Array<ServiceListItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ServicePlan/GetServicesAddons',
      query: {
        'branchId': branchId,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postServicePlanCreateNewQuota(
requestBody?: NewQuotaInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ServicePlan/CreateNewQuota',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param isShedule 
   * @returns any Success
   * @throws ApiError
   */
  public static getServicePlanGetSubscription(
id?: string,
isShedule?: boolean,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ServicePlan/GetSubscription',
      query: {
        'id': id,
        'isShedule': isShedule,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postServicePlanGenerateServicePlanPdf(
requestBody?: ServicePlanInputPdf,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ServicePlan/GenerateServicePlanPdf',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param quotaId 
   * @returns any Success
   * @throws ApiError
   */
  public static patchServicePlanSignServicePlan(
quotaId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/ServicePlan/SignServicePlan',
      query: {
        'quotaId': quotaId,
      },
    });
  }

  /**
   * @param quotaId 
   * @returns any Success
   * @throws ApiError
   */
  public static getServicePlanGetServicePlan(
quotaId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ServicePlan/GetServicePlan',
      query: {
        'quotaId': quotaId,
      },
    });
  }

  /**
   * @param regNo 
   * @param customerEmail 
   * @param status
 *
 * 0 = Subscribe
 *
 * 1 = SignedNotCompleted
 *
 * 2 = Cancelled
   * @returns ServicePlanDetailDto Success
   * @throws ApiError
   */
  public static getServicePlanGetServicePlanDetails(
regNo?: string,
customerEmail?: string,
status?: ServicePlanDetailsStatus,
): CancelablePromise<Array<ServicePlanDetailDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ServicePlan/GetServicePlanDetails',
      query: {
        'regNo': regNo,
        'customerEmail': customerEmail,
        'status': status,
      },
    });
  }

  /**
   * @param vrm 
   * @returns CapHpiDvlaDTO Success
   * @throws ApiError
   */
  public static getServicePlanLookUpVehicle(
vrm?: string,
): CancelablePromise<Array<CapHpiDvlaDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ServicePlan/LookUpVehicle',
      query: {
        'vrm': vrm,
      },
    });
  }

}
